import moment from 'moment'
import numeral from 'numeral'

import { roundN, round2 } from '@/lib/math'

import { formatBytes, formatCurrency, ellipsis } from '@/lib/textutil'

import { formatDate, DateFormat } from '@/lib/dateutil'

const GlobalFilters = {
  install(Vue) {
    Vue.filter('roundN', roundN)
    Vue.filter('round2', round2)
    Vue.filter('addComma', (num, isInt) => {
      if (isInt) {
        return numeral(num).format('0,0')
      }
      return numeral(num).format('0,0.00')
    })
    Vue.filter('formatBytes', formatBytes)
    Vue.filter('ellipsis', ellipsis)

    Vue.filter('formatDate', (date) => formatDate(date, DateFormat.Date))

    Vue.filter('upper', (str) => str.toUpperCase())

    Vue.filter('moment_format', (str, fmt) =>
      str ? moment(str).format(fmt) : ''
    )

    Vue.filter('currency', formatCurrency)
    Vue.filter('formatCurrency', formatCurrency)

    Vue.filter('parseInteger', (num) => parseInt(num, 0))
  },
}

export default GlobalFilters
